module.exports = __webpack_public_path__ + "img/4_31.6ac8b667.png";